module.exports = __webpack_public_path__ + "img/editIncidentType.16311712.svg";